import React from "react";

// Elegant text logo. Design so it can be swapped for an <img /> later
// without changing the layout. Kept centered by parent container.
export const Logo = ({ size = "md", withMonogram = true, testId = "tanish-logo" }) => {
  const sizes = {
    sm: {
      title: "text-lg tracking-[0.28em]",
      mono: "text-[10px] tracking-[0.2em]",
    },
    header: {
      title: "text-[13px] tracking-[0.14em] min-[375px]:text-sm min-[375px]:tracking-[0.18em] sm:text-lg sm:tracking-[0.28em]",
      mono: "text-[9px] tracking-[0.14em] sm:text-[10px] sm:tracking-[0.2em]",
    },
    md: {
      title: "text-lg tracking-[0.22em] sm:text-3xl sm:tracking-[0.35em]",
      mono: "text-[9px] tracking-[0.14em] sm:text-[11px] sm:tracking-[0.35em]",
    },
    lg: {
      title: "text-4xl tracking-[0.3em] sm:text-5xl sm:tracking-[0.35em]",
      mono: "text-xs tracking-[0.25em] sm:text-sm sm:tracking-[0.35em]",
    },
  }[size];

  return (
    <div data-testid={testId} className="inline-flex shrink-0 flex-col items-center select-none">
      <h1
        className={`whitespace-nowrap font-serif font-light text-maroon ${sizes.title}`}
        style={{ fontVariant: "small-caps" }}
      >
        TANISH TEXTILES
      </h1>
      {withMonogram && (
        <p className={`mt-2 whitespace-nowrap uppercase text-muted2 ${sizes.mono}`}>
          Bridal · Couture · Since Generations
        </p>
      )}
    </div>
  );
};

export default Logo;
